/**
 * index.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 모바일 브랜드&분양페이지 Header 렌더링의 햄버거 버튼 영역 및 활성화 시 영역 컴포넌트
 *
 * -----------------------------------------------------------------------------------------------
 */

import './BurgerMenu.scss';
import 'react-slidedown/lib/slidedown.css';

import { useEffect, useState } from 'react';
import { SlideDown } from 'react-slidedown';
import { toJS } from 'mobx';
import styled, { css } from 'styled-components';
import { useHistory, useLocation } from 'react-router';
import { cloneDeep } from 'lodash';
import { observer, useLocalObservable } from 'mobx-react';

import { HideText } from 'common-modules/general/assets/Styles/Common.style';
import { CloseIcon } from 'common-modules/general/assets/Styles/Mobile/icon';
import { RoutesString } from 'common-modules/general/Config/routesString';
import arrow01 from 'common-modules/general/assets/Mobile/images/common/ico_down_arrow01.png';
import arrow02 from 'common-modules/general/assets/Mobile/images/common/ico_down_arrow02.png';
import HeaderModel, { GNBSubMenu } from 'common-modules/general/Common/Logic/Header/HeaderCommon';
import MobxStore from 'common-modules/general/Store/MobxStore';
import RedirectHelper from 'common-modules/general/Model/RedirectHelper';

interface HeaderProps {
  open?: boolean;
  setIsOpen?: any;
}
const GnbWrapper = styled.div`
  position: fixed;
  background: #fff;
  height: 100vh;
  width: -webkit-calc(100vw - 60px);
  width: calc(100vw - 60px);
  max-width: 100%;
  top: 0;
  right: 0;
  z-index: 195;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
`;
const UtilWrapper = styled.div`
  padding: 0 1.5625rem;
  height: 4.0625rem;
  line-height: 4.0625rem;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  position: relative;
`;
const UtilLink = styled.a`
  display: inline-block;
  font-size: 0.8125rem !important;
  font-family: 'SDGothicNeobTTF-bLt';
  vertical-align: middle;
  span:first-child {
    padding-left: 0;
    border-left: 0;
  }
`;
const Text = styled.span`
  padding: 0 10px;
  padding: 0 0.625rem;
  border-left: 1px solid #eee;
  line-height: 1;
  display: inline-block;
`;

const MenuWrapper = styled.div`
  height: calc(100vh - 65px);
  overflow: scroll;
`;
const LoginArea = styled.div`
  padding: 16px 25px 10px;
  border-bottom: 1px solid #eee;
`;
const LoginBox = styled.div``;
const LoginOn = styled.div``;
const MyPageArea = styled.div`
  position: relative;
`;
const MyPageBtn = styled.button`
  display: inline-block;
  font-size: 1rem;
  font-family: 'SDGothicNeobTTF-eSm';
  vertical-align: middle;
  position: relative;
  padding: 0;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: center;
  &::after {
    content: '';
    display: block;
    background: url(${arrow02}) no-repeat;
    width: 0.75rem;
    height: 0.4375rem;
    margin-left: 0.5rem;
    background-size: 0.75rem 0.4375rem;
    transform: rotate(0);
    transition: transform 0.2s;
  }
  &.on {
    &::after {
      transform: rotate(180deg);
    }
    span {
      color: #ff671d;
    }
  }
`;
const MyPgaeList = styled.div`
  /* display: ${(props: HeaderProps) => (props.open ? 'block' : 'none')}; */
  z-index: 1;
  line-height: 1;
  margin-top: 0.625rem;
  padding: 0.9375rem;
  white-space: nowrap;
  border-radius: 5px;
  padding: 0.6875rem 0;
`;
const MenuLink = styled.a`
  display: block;
  font-size: 0.8125rem !important;
  padding: 0.75rem 0;
  font-family: 'SDGothicNeobTTF-bLt';
  width: 100%;
  text-align: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
`;
const _MenuBtn = styled.button`
  display: block;
  font-size: 0.8125rem;
  padding: 0.75rem 0;
  font-family: 'SDGothicNeobTTF-bLt';
  width: 100%;
  text-align: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
`;
const GnbMenuWrapper = styled.div`
  padding: 1.5625rem;
  padding-bottom: 7.5rem;
`;
const GnbMenuList = styled.ul``;
const GnbMenuItem = styled.li`
  padding: 1.25rem 0;
`;
const GnbMenuLink = styled.span`
  display: block;
  font-size: 1.6875rem;
  font-family: 'SDGothicNeobTTF-eSm';
  position: relative;
  &::after {
    content: '';
    display: inline-block;
    background: url(${arrow01}) no-repeat;
    width: 0.75rem;
    height: 0.4375rem;
    position: absolute;
    top: 50%;
    margin-top: -0.21875rem;
    right: 0;
    background-size: 0.75rem 0.4375rem;
    transition: transform 0.2s;
  }
  &.on {
    font-family: 'SDGothicNeobTTF-dMd';
    color: #ff671d;
    &::after {
      transform: rotate(180deg);
    }
  }
`;
const SubMenuList = styled.ul``;
const SubMenuItem = styled.li`
  margin-top: 1.25rem;
`;
const SubMenuLink = styled.a<{ highlight?: boolean }>`
  display: block;
  font-size: 0.9375rem !important;
  font-family: 'SDGothicNeobTTF-bLt' !important;

  ${props =>
    props.highlight &&
    css`
      span {
        font-family: 'SDGothicNeobTTF-dMd';
        color: #ff671d;
      }
    `};
`;
const GnbFooter = styled.div`
  border-top: 1px solid #eee;
  padding: 0 1.5625rem;
  height: 3.125rem;
  line-height: 3.125rem;
  width: calc(100% + 50px);
  box-sizing: border-box;
  margin-left: -1.5625rem;
`;
const FooterLink = styled.a`
  padding: 0 0.9375rem;
  font-size: 0.8125rem;
  color: #999;
  position: relative;
  display: inline-block;
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }
  &::after {
    content: '';
    position: absolute;
    width: 1px;
    height: 11px;
    top: 50%;
    transform: translate(0, -50%);
    left: -0.5px;
    background: #eee;
  }
`;
const CloseBtn = styled.button`
  position: absolute;
  width: 3.75rem;
  height: 3.75rem;
  top: 0;
  left: -3.75rem;
`;

const BurgerMenuWrap = observer(({ setIsOpen }) => {
  const {
    authManager: { userData, initAuthData }
  } = MobxStore();
  const location = useLocation();
  const { model: mainModel } = useLocalObservable(() => ({
    model: new HeaderModel()
  }));
  const menuList = toJS(mainModel.getMenuList());

  const getSelectedMenu = (_menuList: Array<GNBSubMenu>): GNBSubMenu | null => {
    const { pathname } = location;
    const sorted = cloneDeep(_menuList).sort((a, b) => b.urlBizLndLnk.split('/').length - a.urlBizLndLnk.split('/').length);
    const findItem = sorted.find(data => pathname.includes(data.cdBizLnd));

    if (findItem) {
      return findItem;
    } else {
      return null;
    }
  };

  const [isMyMenuOpen, setMyMenuOpen] = useState<boolean>(false);
  const [selectSubMenu, setSelectSubMenu] = useState<string>('분양');

  const [Show, setShow] = useState<boolean>(false);

  useEffect(() => {
    mainModel.getData();
  }, []);

  const handleSelectSub = (menu: string) => {
    if (menu === selectSubMenu) {
      setSelectSubMenu('');
    } else {
      setSelectSubMenu(menu);
    }
  };
  const history = useHistory();
  const redirectHelper = new RedirectHelper();

  const handleClickLoginButton = () => {
    const isDiffOrigin = RoutesString.Login.includes('http');
    const path = isDiffOrigin ? window.location.href : history.location.pathname;

    redirectHelper.setPageRedirectData(path, isDiffOrigin ? 'diff' : 'same-origin');
    window.location.href = RoutesString.Login;
  };

  const renderMenu = () => {
    return menuList.subMenuList.map((item, key) => {
      return (
        <GnbMenuItem key={`${item.name}_${key}`}>
          <GnbMenuLink onClick={() => handleSelectSub(item.name)} className={item.name === selectSubMenu ? 'on' : ''}>
            <HideText>선택됨</HideText>
            <span className="txt">{item.name}</span>
          </GnbMenuLink>
          <SlideDown closed={item.name !== selectSubMenu}>
            <SubMenuList>
              {item.menuList.map((val, idx) => {
                const isHighlight = location.pathname.includes(val.cdBizLnd);

                return (
                  <SubMenuItem key={`${val.cdBizLnd}_${idx}`}>
                    <SubMenuLink href={val.urlBizLndLnk} highlight={isHighlight}>
                      <HideText>선택됨</HideText>
                      <span>{val.nmBizLnd}</span>
                    </SubMenuLink>
                  </SubMenuItem>
                );
              })}
            </SubMenuList>
          </SlideDown>
        </GnbMenuItem>
      );
    });
  };

  return (
    <GnbWrapper>
      <div className="gnb-dimm" aria-hidden="true"></div>
      <UtilWrapper>
        <UtilLink href={RoutesString.FooterFoundList}>
          <Text>e편한세상 찾기</Text>
        </UtilLink>
        {!userData && (
          <UtilLink onClick={handleClickLoginButton}>
            <Text>로그인</Text>
          </UtilLink>
        )}
      </UtilWrapper>
      <MenuWrapper>
        {userData && (
          <LoginArea>
            <LoginBox>
              <LoginOn>
                <MyPageArea>
                  <MyPageBtn onClick={() => setMyMenuOpen(!isMyMenuOpen)} className={`${isMyMenuOpen ? 'on' : ''}`} type="button">
                    <span>{userData.nmMbrActl}님</span>
                  </MyPageBtn>
                  <SlideDown closed={!isMyMenuOpen}>
                    <MyPgaeList open={isMyMenuOpen}>
                      <MenuLink href={RoutesString.ConfirmPassword}>개인정보 변경</MenuLink>
                      <MenuLink href={RoutesString.ContractInfoChange}>계약정보 변경</MenuLink>
                      <MenuLink href={RoutesString.ChangePW}>비밀번호 변경</MenuLink>
                      <MenuLink href={RoutesString.IntersetComplex}>관심단지</MenuLink>
                      <MenuLink onClick={() => initAuthData(true)}>로그아웃</MenuLink>
                    </MyPgaeList>
                  </SlideDown>
                </MyPageArea>
              </LoginOn>
            </LoginBox>
          </LoginArea>
        )}
        <GnbMenuWrapper>
          <GnbMenuList>{renderMenu()}</GnbMenuList>
          <GnbFooter>
            <FooterLink href={RoutesString.FooterNotice}>공지사항</FooterLink>
            <FooterLink href={RoutesString.FooterEvent01}>이벤트</FooterLink>
            <FooterLink href={RoutesString.FooterQuestion}>고객문의</FooterLink>
          </GnbFooter>
        </GnbMenuWrapper>
      </MenuWrapper>
      <CloseBtn type="button" onClick={() => setIsOpen(false)}>
        <CloseIcon></CloseIcon>
        <HideText>닫기</HideText>
      </CloseBtn>
    </GnbWrapper>
  );
});

export default BurgerMenuWrap;
